import { render, staticRenderFns } from "./ForumThread.vue?vue&type=template&id=1c624011&"
import script from "./ForumThread.vue?vue&type=script&lang=js&"
export * from "./ForumThread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports